import NormalTextIcon from "@assets/icons/editor/normal-text.svg";
import Heading1Icon from "@assets/icons/editor/heading-1.svg";
import Heading2Icon from "@assets/icons/editor/heading-2.svg";
import Heading3Icon from "@assets/icons/editor/heading-3.svg";
import ListDotIcon from "@assets/icons/editor/list-dot.svg";
import ListNumberIcon from "@assets/icons/editor/list-number.svg";
import ListCheckIcon from "@assets/icons/editor/list-check.svg";
import BoldIcon from "@assets/icons/editor/bold.svg";
import ItalicIcon from "@assets/icons/editor/italic.svg";
import UnderlineIcon from "@assets/icons/editor/underline.svg";
import StrikethroughIcon from "@assets/icons/editor/strikethrough.svg";
import LinkIcon from "@assets/icons/editor/link.svg";

import type { Action, Divider } from "./types";

export const DEFAULT_ACTIONS: (Action | Divider)[] = [
  {
    icon: NormalTextIcon,
    label: "Text styles",
    isActive: () => false,
    disabled: () => false,
    children: [
      {
        icon: NormalTextIcon,
        label: "Normal text",
        onClick: (editor) => editor.chain().focus().setParagraph().run(),
        isActive: (editor) => editor.isActive("paragraph"),
        disabled: () => false,
      },
      {
        icon: Heading1Icon,
        label: "Heading 1",
        onClick: (editor) => editor.chain().focus().setHeading({ level: 1 }).run(),
        isActive: (editor) => editor.isActive("heading", { level: 1 }),
        disabled: (editor) => !editor.can().chain().focus().setHeading({ level: 1 }).run(),
      },
      {
        icon: Heading2Icon,
        label: "Heading 2",
        onClick: (editor) => editor.chain().focus().setHeading({ level: 2 }).run(),
        isActive: (editor) => editor.isActive("heading", { level: 2 }),
        disabled: (editor) => !editor.can().chain().focus().setHeading({ level: 2 }).run(),
      },
      {
        icon: Heading3Icon,
        label: "Heading 3",
        onClick: (editor) => editor.chain().focus().setHeading({ level: 3 }).run(),
        isActive: (editor) => editor.isActive("heading", { level: 3 }),
        disabled: (editor) => !editor.can().chain().focus().setHeading({ level: 3 }).run(),
      },
      {
        divider: true,
      },
      {
        icon: ListDotIcon,
        label: "Bulleted list",
        onClick: (editor) => editor.chain().focus().toggleBulletList().run(),
        isActive: (editor) => editor.isActive("bulletList"),
        disabled: () => false,
      },
      {
        icon: ListNumberIcon,
        label: "Numbered list",
        onClick: (editor) => editor.chain().focus().toggleOrderedList().run(),
        isActive: (editor) => editor.isActive("orderedList"),
        disabled: () => false,
      },
      {
        icon: ListCheckIcon,
        label: "Check list",
        onClick: (editor) => editor.chain().focus().toggleTaskList().run(),
        isActive: (editor) => editor.isActive("taskList"),
        disabled: () => false,
      },
    ],
  },
  {
    icon: BoldIcon,
    label: "Bold",
    onClick: (editor) => editor.chain().focus().toggleBold().run(),
    isActive: (editor) => editor.isActive("bold"),
    disabled: (editor) => !editor.can().chain().focus().toggleBold().run(),
  },
  {
    icon: ItalicIcon,
    label: "Italic",
    onClick: (editor) => editor.chain().focus().toggleItalic().run(),
    isActive: (editor) => editor.isActive("italic"),
    disabled: (editor) => !editor.can().chain().focus().toggleItalic().run(),
  },
  {
    icon: UnderlineIcon,
    label: "Underline",
    onClick: (editor) => editor.chain().focus().toggleUnderline().run(),
    isActive: (editor) => editor.isActive("underline"),
    disabled: (editor) => !editor.can().chain().focus().toggleUnderline().run(),
  },
  {
    icon: StrikethroughIcon,
    label: "Strikethrough",
    onClick: (editor) => editor.chain().focus().toggleStrike().run(),
    isActive: (editor) => editor.isActive("strike"),
    disabled: (editor) => !editor.can().chain().focus().toggleStrike().run(),
  },
  {
    icon: LinkIcon,
    label: "Link",
    onClick: (editor) => editor.chain().focus().openLinkDialog().run(),
    isActive: (editor) => editor.isActive("link"),
    disabled: () => false,
  },
];
